/* ============================================================
   SDCOME FIX 2026-10-27 (C29): scroll wrapper for rich-text tables
   (collection block 2). Styles: assets/sdcome-rte-tables.css.
   Loaded (defer) by snippets/sdcome-head.liquid only on collection pages
   whose block 2 contains a <table>.
   For each plain table (no class) inside .rte it builds, in the browser only:
     div.sd-tscroll[.is-wide]
       p.sd-tscroll__hint (aria-hidden, "Scroll sideways to see all columns")
       div.sd-tscroll__frame
         div.sd-tscroll__inner   <- the horizontal scroller
           <table> (moved, not changed or copied)
   The saved HTML in the metafield is not touched; crawlers that do not run
   JS see the same table as today, crawlers that do see the same table
   one level deeper.
   While the table is wider than the box, the scroller becomes a named,
   keyboard-focusable region (role=region, aria-label, tabindex=0), and
   is-overflowing / is-scrolled / is-end classes drive the hint, the edge fade
   and the sticky-column shadow. When it fits, those are removed again.
   It also sets --sd-cols (column count) on the wrapper it creates, which
   the CSS uses for the phone table width. Nothing is set on content markup.
   If this file fails to load or JavaScript is off, the CSS still sizes the
   columns and gives the table a plain sideways scroll (no sticky column,
   hint or fade).
   Revert: delete this file, assets/sdcome-rte-tables.css and the C29
   block in snippets/sdcome-head.liquid.
   ============================================================ */
(function () {
  'use strict';
  var tables = document.querySelectorAll('.rte table:not([class])');
  if (!tables.length) return;

  function columnCount(table) {
    var row = table.rows[0];
    var n = 0;
    if (!row) return 0;
    for (var i = 0; i < row.cells.length; i++) n += row.cells[i].colSpan || 1;
    return n;
  }

  function labelFor(table, wrap, cols) {
    if (table.caption && table.caption.textContent.trim()) return table.caption.textContent.trim();
    var el = wrap;
    while (el && el.parentElement && !el.previousElementSibling) el = el.parentElement;
    el = el ? el.previousElementSibling : null;
    for (var i = 0; el && i < 6; i++, el = el.previousElementSibling) {
      if (/^H[2-4]$/.test(el.tagName) && el.textContent.trim()) return el.textContent.trim();
    }
    return 'Table, ' + cols + ' columns';
  }

  Array.prototype.forEach.call(tables, function (table) {
    if (table.closest('.sd-tscroll')) return;
    var parent = table.parentElement;
    if (parent && parent !== table.closest('.rte') && /scroll/i.test(parent.className || '')) return;

    var cols = columnCount(table);
    var wrap = document.createElement('div');
    wrap.className = 'sd-tscroll' + (cols >= 4 ? ' is-wide' : '');
    wrap.style.setProperty('--sd-cols', cols);
    var hint = document.createElement('p');
    hint.className = 'sd-tscroll__hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Scroll sideways to see all columns';
    var frame = document.createElement('div');
    frame.className = 'sd-tscroll__frame';
    var inner = document.createElement('div');
    inner.className = 'sd-tscroll__inner';

    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(hint);
    wrap.appendChild(frame);
    frame.appendChild(inner);
    inner.appendChild(table);

    var label = labelFor(table, wrap, cols);
    var queued = false;

    function update() {
      queued = false;
      var max = inner.scrollWidth - inner.clientWidth;
      var over = max > 1;
      var x = Math.abs(inner.scrollLeft);
      wrap.classList.toggle('is-overflowing', over);
      wrap.classList.toggle('is-scrolled', over && x > 1);
      wrap.classList.toggle('is-end', !over || x >= max - 1);
      if (over) {
        inner.setAttribute('role', 'region');
        inner.setAttribute('aria-label', label + ' (scrolls sideways)');
        inner.tabIndex = 0;
      } else {
        inner.removeAttribute('role');
        inner.removeAttribute('aria-label');
        inner.removeAttribute('tabindex');
      }
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    // Keyboard: browsers leave a partly visible focused link where it is, which
    // can be half under the sticky first column or past the right edge.
    // Scroll just enough to show it fully, beside the sticky column.
    inner.addEventListener('focusin', function (e) {
      if (e.target === inner || !wrap.classList.contains('is-overflowing')) return;
      // A link in a sticky first-column cell is always in view: leave it.
      var cell = e.target.closest('th, td');
      if (cell && cell === cell.parentElement.firstElementChild &&
          window.getComputedStyle(cell).position === 'sticky') return;
      var c = e.target.getBoundingClientRect();
      var v = inner.getBoundingClientRect();
      var left = v.left;
      var stick = table.rows[0] && table.rows[0].cells[0];
      if (stick && window.getComputedStyle(stick).position === 'sticky') {
        left = stick.getBoundingClientRect().right;
      }
      if (c.left < left) inner.scrollLeft -= left - c.left + 8;
      else if (c.right > v.right) inner.scrollLeft += c.right - v.right + 8;
    });

    inner.addEventListener('scroll', queue, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(queue);
      ro.observe(inner);
      ro.observe(table); // table width changes when the web font swaps in
    } else {
      window.addEventListener('resize', queue);
    }
    update();
  });
})();
/* END SDCOME FIX C29 */
